<sc-flex vertical fitHeight stretchContent>
  <sc-flex-fitting-content vertical>
    <sc-master-detail [data]="visibleStationGroups" [selection]="selection" [newStyle]="true"
      (selectionChanged)="onSelectionChanged($event);" [saveAllMode]="true" (addEntry)="onAddEntry($event)"
      (deleteEntry)="onDeleteEntry($event)">
      <sc-padding fitHeight>
        <sc-scroll-pane>
          <form #form="ngForm" class="form no-field-space">
            @if (stationSet == null) {
              <app-stationgroup-details [stationGroup]="stationGroup">
              </app-stationgroup-details>
            }
            @if (stationSet != null) {
              <app-stationset [form]="form" [stationSet]="stationSet" [stationGroup]="stationGroup" class="main"
                >
              </app-stationset>
            }
          </form>
        </sc-scroll-pane>
      </sc-padding>
      <ng-template masterDetailToolbar>
        @if (form.dirty) {
          <div class="message-container">
            <sc-padding>
              <div class="configChangedText">
                <sc-dictionary-label dictionaryKey="tmc.stationgroup.configChanged"></sc-dictionary-label>
              </div>
            </sc-padding>
            <div class="button-bar">
              <sc-cancel-button type="button" fitWidth (click)="cancel()"></sc-cancel-button>
              <sc-content-spacer vertical></sc-content-spacer>
              <sc-save-button type="button" fitWidth [disabled]="isSaveDisabled()" (click)="saveChanges()"
              primary></sc-save-button>
              <sc-content-spacer vertical></sc-content-spacer>
            </div>
          </div>
        }
      </ng-template>
    </sc-master-detail>
  </sc-flex-fitting-content>
</sc-flex>
